/**
 * The two marks the Sept 19 account mockups draw that the brand's icon set
 * does not have: a chain link for the public link, and a calendar with the
 * pair of arrows that says "and it keeps itself up to date".
 *
 * Drawn here rather than run through `scripts/build-icons.mjs`, which reads
 * SVGs out of `_Dev process/` — there is no source file for either.
 */

export const LinkGlyph = ({ size = 24 }: { size?: number }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={1.9}
    strokeLinecap="round"
    aria-hidden="true"
    focusable="false"
  >
    <path d="M9.4 14.6 14.6 9.4" />
    <path d="M11.6 6.6 13.8 4.4a4.3 4.3 0 0 1 6.1 6.1l-2.2 2.2" />
    <path d="M12.4 17.4l-2.2 2.2a4.3 4.3 0 0 1-6.1-6.1l2.2-2.2" />
  </svg>
);

export const CalendarSyncGlyph = ({ size = 24 }: { size?: number }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={1.7}
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    focusable="false"
  >
    <path d="M20 12.2V7a2.4 2.4 0 0 0-2.4-2.4H5.4A2.4 2.4 0 0 0 3 7v10.2a2.4 2.4 0 0 0 2.4 2.4h6.4" />
    <path d="M7.6 2.8v3.6M15.4 2.8v3.6M3 9.6h17" />
    {/* The pair of arrows that says "and it keeps itself up to date". */}
    <path d="M19.9 16.1a3.4 3.4 0 0 0-5.9-1.5" />
    <path d="M13.4 18a3.4 3.4 0 0 0 5.9 1.5" />
    <path d="M13.8 12.4v2.2h2.2M19.5 21.4v-2.2h-2.2" />
  </svg>
);
